import { useSelector } from 'react-redux';
import { dataSelector } from '@nextiva/global-store';

export function useCorpAccountNumber() {
  const globalStoreData = useSelector(dataSelector);
  const corpAccountNumber: number =
    globalStoreData.user?.profileDTO?.corpAcctNbr;

  return {
    corpAccountNumber,
  };
}
